import axios from 'axios'
import { getHost } from './host'
import { User } from '../store/users/types'

/**
 * Making a GET reqeust to get Users detail
 * 
 * @param   {string}        api_key         API key of the current user
 * @param   {string}        account_id      Account id of the current user, this can be the masquerade id too
 *
 * @return	{Array}				                  Response of the request users array of objects
 */

export async function getUsers(api_key: string, account_id: number | string) {
  const url = `https://${getHost()}/api/users`

  const params = {
    account_id: account_id
  }

  const { data } = await axios.get<{ data: Array<User> }>(
    url, 
    { 
      headers: {'X-API-KEY': api_key, Accept: 'application/json'},
      params: params
    }
  );
  return data.data
}

